import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../../app/appConstants";

export const ZendeskButtonWrapper = styled.div`
    button {
        width: 100%;
    }
    svg {
        margin-right: 8px;
    }
`;

export const ProfileButtonToggleStyled = styled.button`
    border: none;
    padding: 0;
    background: none;
    display: flex;
    align-items: center;
    svg {
        fill: var(--icon-primary-color);
    }
    &:hover:not(:disabled) {
        svg {
            fill: var(--color-white);
        }
    }
    &:after {
        display: none;
    }
`;

export const ProfileButtonDropdownStyled = styled.div`
    .profile-icon-arrow {
        transition: transform 200ms ease;
    }
    
    &.show {
        .profile-icon-arrow {
            transform: rotate(180deg);
        }
    }
`;

export const ProfileButtonDropdownItemStyled = styled.div`
    display: flex;
    align-items: center;
    svg {
        margin-right: 8px;
        fill: var(--color-secondary-active);
        font-size: 16px !important;
    }

    .new {
        font-size: 14px !important;
        position: absolute;
        display: block;
        right: 16px;
        text-align: right;
        background-color: var(--color-positive);
        color: #000000;
        border-radius: 4px;
        padding: 0 6px;
    }
`;

export const ProfileButtonDropdownHeaderStyled = styled(ProfileButtonDropdownItemStyled)`
    svg {
        margin-right: 12px;
    }
`;

export const ProfileButtonPanelWrapper = styled.div`
    margin: 4px;
    
    @media(max-width: ${BREAKPOINTS.small}px) {
        margin: 8px;
    }
`;
